'use client';

import { Box, Button, Flex } from '@/ui';
import type { FC } from 'react';
import { ArrowUpIcon } from 'xyz-icon-set-react/dist/icons/ArrowUpIcon';
import { useTruth } from '../hooks/useTruth';
import { messages } from '../messages';

export const ScrollUpButton: FC = () => {
  const { setRevealed } = useTruth();

  const scrollUp = () => {
    document.body.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    setRevealed(true);
  };

  return (
    <Box marginTop={80} marginBottom={80}>
      <Flex
        flexDirection="column"
        alignContent="center"
        alignItems="center"
        justifyContent="center"
      >
        <Button
          size="S"
          variant="hollow"
          onClick={scrollUp}
          frameAnimation="pulsing"
          leadingIcon={<ArrowUpIcon />}
          trailingIcon={<ArrowUpIcon />}
        >
          {messages['readAgain']}
        </Button>
      </Flex>
    </Box>
  );
};
